exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".receiver-item>.v-list__tile--avatar{height:auto}", ""]);

// exports
